<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>

<div class="container" (keydown)="keyDownFunction($event)">
    <div class="row">
        <div class="col-24">
            <h1 class="medium">Section 1 :Beneficiary Information</h1>
        </div>
    </div>

    <button #focusableEleTop class="focusable-element"></button>
    <div class="row" *ngIf="hasError">
        <div class="col-24">
            <div class="alert danger">
                <p><em>Mensaje de error:</em></p>
                <ul>
                    <li *ngFor="let error of ErrorMessages">
                        <button [innerHtml]="error"></button>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            <p class="required">Todos los campos son obligatorios, a menos que estén marcados como opcionales.</p>
        </div>
    </div>
    <div>

        <!--<div *ngIf="!ShowCurrentYearScript">
            <div class="row">
                <div class="col-16">
                    <p class="blue-text bottom-20">Thank you for calling SilverScript, my name is {{agentFullname}}, how can I help you today? </p>
                </div>
            </div>
            <div class="row">
                <div class="col-16">
                    <p class="blue-text bottom-20">Let’s go ahead and start your enrollment today in SilverScript (PDP) plan.</p>
                </div>
            </div>
            <div class="row">
                <div class="col-16">
                    <fieldset class="radio">
                        <legend class="blue-text">To take your application over the phone, Medicare requires us to record this conversation. May we record the conversation?</legend>
                        <ValidatedRadioButtonGroup [options]="rblrecord"
                                                   [selectedValue]="enrollment.RBLRECORD"
                                                   (onValueChange)="SelectRblrecordOptions($event)"
                                                   [radioGroupName]="'rblrecord'">
                        </ValidatedRadioButtonGroup>
                    </fieldset>
                </div>
            </div>
            <div *ngIf="!rblrecordyes">
                <div class="row">
                    <div class="col-16">
                        <p class="blue-text">I’m sorry, but I’m not permitted to assist with your enrollment by phone unless it is recorded. As an alternative, if you desire to enroll with SilverScript, I can send you a paper enrollment form to complete and mail back, or you may enroll online at <a class="link" href="https://www.silverscript.com" target="_blank">www.silverscript.com</a></p>
                    </div>
                </div>
                <div class="row" *ngIf="isQtip">
                    <div class="col-16">
                        <div *ngIf="checkPlanyear">
                            <p class="qtip-note"><strong>qTip Note:</strong> If caller elects to receive a paper enrollment form, select <u>HICN hyperlink</u> to verify information in MARx, then input the enrollee’s mailing address in <u>“Section 2. Beneficiary Information”</u> and proceed to <u>“Section 6. Enrollment End”</u>. Disposition as Requested Paper Enrollment Form. <a (click)="BenfDetails()" class="link">Click here</a></p>
                            <p class="qtip-note">
                                <strong>qTip Note:</strong> :  If caller declines recording of the call and has elected to receive a paper enrollment form, proceed to <u>“Section 2. Beneficiary Information”</u> and input the enrollee’s name and mailing address.
                                <a (click)="BenfDetails()" class="link"> Click here</a>
                            </p>
                            <p class="qtip-note"><strong>qTip Note:</strong> If caller does not agree to recording of the conversation, does not request a paper enrollment and does not want to enroll at <a class="link" href="https://www.silverscript.com" target="_blank">www.silverscript.com</a>, proceed to <u>“Section 6. Enrollment End”</u> and disposition as Ineligible – Declined Recorded Conversation. <a (click)="SalesBenfDetails()" class="link"> Click here</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>-->


        <div>
            <div class="row">
                <div class="col-16">
                    <fieldset class="radio">
                        <legend class="blue-text" *ngIf="ShowCurrentYearScript">
                            Gracias por su interés en inscribirse en un plan de medicamentos con receta ofrecido a
                            través de Aetna. Mi nombre es {{this.enrollment.APPFN}} {{this.enrollment.APPLN}}
                            , soy agente autorizado(a) de CVS Health, la compañía matriz de SilverScript y
                            Aetna.<br /><br />
                            ¿En qué plan {{spndodoes}} inscribirse? <br /><br />
                            La prima del plan {{this.enrollment.PLANTYPENAME}} será de ${{planvalue}}.
                        </legend>
                        <legend class="blue-text" *ngIf="!ShowCurrentYearScript">
                            Gracias por su interés en inscribirse en un plan de medicamentos con receta ofrecido por
                            Aetna. Mi nombre es {{this.enrollment.APPFN}} {{this.enrollment.APPLN}}
                            , soy agente autorizado(a) de CVS Health, la compañía matriz de SilverScript y
                            Aetna.<br /><br />
                            ¿En qué plan {{spndodoes}} inscribirse? <br /><br />
                            La prima del plan {{this.enrollment.PLANTYPENAME}} será de ${{planvalue}}.
                        </legend>
                        <!--<legend class="blue-text" *ngIf="!ShowCurrentYearScript">
            Thank you for expressing an interest in enrolling in a Aetna (PDP) plan.<br /><br />
            What plan do/does you/he/she want to enroll in? <br /><br />
            The premium for {{this.enrollment.PLANTYPENAME}} will be ${{planvalue}}
        </legend>-->
                        <ValidatedRadioButtonGroup [label]="'Plan deseado'" [options]="optionrbPlan"
                            [selectedValue]="enrollment.PLANTYPE" (onValueChange)="onPlanChange($event)"
                            [radioGroupName]="'Plan'">
                        </ValidatedRadioButtonGroup>

                    </fieldset>
                    <p class="blue-text" *ngIf="ShowCurrentYearScript">
                        Antes de comenzar con el proceso de inscripción, me gustaría confirmar que {{spnyoubenef}}
                        entiende que presentará una solicitud de inscripción en el plan
                        {{this.enrollment.PLANTYPENAME}}. Al final de este proceso, enviaremos su solicitud de
                        inscripción a los Centros de Servicios de Medicare y Medicaid, conocidos como CMS, para que
                        realicen la inscripción en el plan. Los CMS son la agencia federal encargada de la
                        administración del programa Medicare.
                        <br />
                        En general, solo {{spnIsAre}} inscribirse o cancelar la inscripción en un plan de Medicare desde
                        el 15 de octubre hasta el 7 de diciembre. Sin embargo, hay excepciones especiales. Por ejemplo,
                        cuando alguien obtuvo o perdió Medicare y Medicaid.
                    </p>
                    <p class="blue-text" *ngIf="!ShowCurrentYearScript">
                        Antes de comenzar con el proceso de inscripción, me gustaría confirmar que {{spnyoubenef}}
                        entiende que presentará una solicitud de inscripción en el plan
                        {{this.enrollment.PLANTYPENAME}}. Al final de este proceso, enviaremos su solicitud de
                        inscripción a los Centros de Servicios de Medicare y Medicaid, conocidos como CMS, para que
                        realicen la inscripción en el plan. Los CMS son la agencia federal encargada de la
                        administración del programa Medicare.
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-16">
                    <fieldset class="radio">
                        <legend class="blue-text">
                            Además, usted entiende que grabaremos esta conversación y está de acuerdo con ello.
                            <br />
                            <br />
                            ¿Quiere continuar?
                        </legend>
                        <ValidatedRadioButtonGroup [options]="rblrecord" [selectedValue]="enrollment.RBLRECORD"
                            (onValueChange)="SelectRblrecordOptions($event)" [radioGroupName]="'rblrecord'">
                        </ValidatedRadioButtonGroup>

                    </fieldset>
                </div>
            </div>

            <div *ngIf="!rblrecordyes">
                <div class="row">
                    <div class="col-16">
                        <p class="blue-text">Si la persona que llama dice que no, diga lo siguiente: “Tenga en cuenta
                            que grabamos todas las solicitudes de inscripción por teléfono. No podemos continuar con
                            esta inscripción, a menos que acepte que grabemos la conversación.“</p>
                    </div>
                </div>
                <div class="row" *ngIf="isQtip">
                    <div class="col-16">
                        <div *ngIf="checkPlanyear">
                            <p class="qtip-note"><strong>qTip Note:</strong> If caller elects to receive a paper
                                enrollment form, select <u>HICN hyperlink</u> to verify information in MARx, then input
                                the enrollee’s mailing address in <u>“Section 2. Beneficiary Information”</u> and
                                proceed to <u>“Section 6. Enrollment End”</u>. Disposition as Requested Paper Enrollment
                                Form. <a (click)="BenfDetails()" class="link">Click here</a></p>
                            <p class="qtip-note">
                                <strong>qTip Note:</strong> : If caller declines recording of the call and has elected
                                to receive a paper enrollment form, proceed to <u>“Section 2. Beneficiary
                                    Information”</u> and input the enrollee’s name and mailing address.
                                <a (click)="BenfDetails()" class="link"> Click here</a>
                            </p>
                        </div>
                        <p class="qtip-note"><strong>qTip Note:</strong>If person still says no, Proceed to <u>“Section
                                7. Enrollment End”</u> <a (click)="SalesBenfDetails()" class="link"> Click here</a></p>

                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="!rblrecordno">
            <div class="row">
                <div class="col-16" *ngIf="ShowCurrentYearScript">
                    <fieldset class="radio">
                        <!--<legend class="blue-text" *ngIf="!ShowCurrentYearScript">Thank you. Before we begin, may I ask if an Insurance Agent or Sales Representative is currently present with you?</legend>-->
                        <legend class="blue-text">Procedamos, entonces, con su inscripción.<br /><br /> Antes de
                            comenzar, ¿podría decirme si está con usted un agente de seguros o un representante de
                            ventas?</legend>
                        <ValidatedRadioButtonGroup [options]="rblRep" [selectedValue]="enrollment.RBLREP"
                            (onValueChange)="SelectRblrecordNoOptions($event)" [radioGroupName]="'rblRep'">
                        </ValidatedRadioButtonGroup>
                    </fieldset>
                </div>
                <div class="col-16" *ngIf="!rblrepno">
                    <p class="blue-text">
                        Lamentablemente, no puedo completar hoy su inscripción por teléfono en presencia de un agente de
                        seguros o un representante de ventas. Tenga en cuenta llamarnos cuando el agente o el
                        representante de ventas no estén presentes o puede inscribirse en línea en <a class="link"
                            href="https://www.AetnaMedicare.com" target="_blank">AetnaMedicare.com</a>.
                    </p>
                    <div class="centerAnswer">
                        <div class="Vdntooltip" *ngIf="isQtip">
                            <p class="qtip-note">
                                <strong>qTip Note:</strong> Answer questions pertaining to why the agent/representative
                                cannot be present during enrollment as applicable, then proceed to <u>“Section 7.
                                    Enrollment End”.</u> <a (click)="SalesBenfDetails()" class="link">Click
                                    here</a><br />
                                <!--If caller wants to receive a paper enrollment form, proceed to <u>“Section 2. Beneficiary Information”</u> and input the enrollee’s name and mailing address. <a (click)="BenfDetails()" class="link">Click here</a>-->
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="!rblrepyes">
                <div class="row">
                    <div class="col-16">
                        <fieldset class="radio">
                            <!--<legend class="blue-text" *ngIf="!ShowCurrentYearScript">Let’s go ahead and start your enrollment.</legend>-->
                            <!--<legend class="blue-text" *ngIf="ShowCurrentYearScript">-->
                            <legend class="blue-text">
                                Actúo en nombre de Aetna y es posible que me compensen si se inscribe/inscriben en un
                                plan.
                                <br /><br />¿Usted será el/la beneficiario/beneficiaria?
                            </legend>
                            <!--<legend class="blue-text" *ngIf="!ShowCurrentYearScript">
                        I am acting on behalf of Aetna and may be compensated based on your/his/her enrollment in a plan.
                        <br /><br />Will you be the beneficiary?
                    </legend>-->
                            <ValidatedRadioButtonGroup [options]="rblBenfe" [selectedValue]="enrollment.RBLBENFE"
                                (onValueChange)="SelectRblrblBenfeOptions($event)" [radioGroupName]="'rblBenfe'">
                            </ValidatedRadioButtonGroup>
                        </fieldset>
                    </div>
                </div>
                <div *ngIf="!rblbenfeyes">
                    <div class="row">
                        <div class="col-16">
                            <fieldset class="radio">
                                <legend class="blue-text">
                                    Como usted llama en nombre del beneficiario, Medicare nos exige confirmar dos cosas.
                                    <br /><br />
                                    1. En primer lugar, que usted tenga autorización para actuar en nombre del
                                    beneficiario de Medicare en virtud de la ley estatal.<br />
                                    2. En segundo lugar, que usted nos pueda suministrar documentación de esta
                                    autorización si la solicita Medicare. <br /><br />
                                    ¿Confirma estas dos cosas?<br />
                                </legend>
                                <ValidatedRadioButtonGroup [options]="rblBenfereply"
                                    [selectedValue]="enrollment.RBLBENFEREPLY"
                                    (onValueChange)="SelectRblrblBenfeReplyOptions($event)"
                                    [radioGroupName]="'rblBenfereply'">
                                </ValidatedRadioButtonGroup>
                            </fieldset>
                        </div>
                    </div>
                    <div class="row" *ngIf="!rblbenfereplyyes && !visibleFrom2025">
                        <div class="col-16">
                            <p class="blue-text"> Le pido disculpas, pero solo puedo tomar la inscripción del
                                beneficiario de Medicare o de una persona que esté autorizada para actuar en nombre.
                            </p>
                        </div>

                        <div class="col-16" *ngIf="isQtip">
                            <div>
                                <p class="qtip-note"><strong>qTip Note:</strong> Proceed to <u>“Section 7. Enrollment
                                        End”</u>.<a (click)="SalesBenfDetails()" class="link">Click here</a></p>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="!rblbenfereplyno">
                        <div class="row">
                            <div class="col-16">
                                <p class="qtip-note bottom-20"><strong> Nota:</strong> Si la persona que llama PUEDE
                                    certificar las 2 condiciones, se REQUIERE la captura de información para un
                                    representante autorizado.</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-16">
                                <p class="blue-text">¿Podría informarme lo siguiente? </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <div class="input-wrapper">
                                    <ValidatedTextField [label]="'Nombre del representante legalmente autorizado:'"
                                        [text]="enrollment.AUTHREPNAME" [maxlength]="100"
                                        (onValueChange)="enrollment.AUTHREPNAME = $event" [validators]="[]">
                                    </ValidatedTextField>
                                </div>
                            </div>
                            <div class="col-8">
                                <div class="input-wrapper">
                                    <MaskedValidatedTextField [label]="'Número de teléfono'" [maxlength]="10"
                                        [text]="enrollment.AUTHREPPHONE" [inputMask]="phoneNumberInputMask"
                                        (onValueChange)="enrollment.AUTHREPPHONE = $event" [validators]="[]">
                                    </MaskedValidatedTextField>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-8">
                                <div class="input-wrapper">
                                    <ValidatedTextField [label]="'Dirección 1'" [text]="enrollment.AUTHREPADD1"
                                        [maxlength]="100" (onValueChange)="enrollment.AUTHREPADD1 = $event"
                                        [validators]="[]">
                                    </ValidatedTextField>
                                </div>
                            </div>
                            <div class="col-8">
                                <div class="input-wrapper">
                                    <ValidatedTextField [label]="'Dirección 2 (opcional)'"
                                        [text]="enrollment.AUTHREPADD2" [maxlength]="100"
                                        (onValueChange)="enrollment.AUTHREPADD2 = $event">

                                    </ValidatedTextField>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <div class="input-wrapper">
                                    <ValidatedTextField [label]="'Ciudad'" [text]="enrollment.AUTHREPCITY"
                                        [maxlength]="50" (onValueChange)="enrollment.AUTHREPCITY = $event"
                                        [validators]="[]">
                                    </ValidatedTextField>
                                </div>
                            </div>
                            <div class="col-5">
                                <div class="input-wrapper">
                                    <ValidatedDropDown class="wide" [selectedValue]="enrollment.AUTHREPST"
                                        [label]="'Estado'" [disabled]="'false'"
                                        (onValueChange)="enrollment.AUTHREPST  = $event" [options]="authrepstates">

                                    </ValidatedDropDown>
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="input-wrapper">
                                    <ValidatedTextField [label]="'Código postal'" [maxlength]="5"
                                        [text]="enrollment.AUTHREPZIP" (onValueChange)="enrollment.AUTHREPZIP = $event"
                                        [validators]="[]">
                                    </ValidatedTextField>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <div class="input-wrapper">
                                    <ValidatedDropDown class="wide" [label]="'Relación con la persona inscrita'"
                                        [disabled]="'false'" [selectedValue]="enrollment.AUTHREPREL"
                                        (onValueChange)="enrollment.AUTHREPREL =$event" [options]="rblRelation">
                                    </ValidatedDropDown>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <div class="input-wrapper">
                                    <ValidatedTextField [label]="'Dirección de correo electrónico (opcional)'"
                                        [maxlength]="60" [text]="enrollment.AUTHREPEMAIL "
                                        (onValueChange)="enrollment.AUTHREPEMAIL  = $event">
                                    </ValidatedTextField>
                                </div>
                            </div>
                            <!--<div class="col-8">
                                <div class="input-wrapper">
                                    <ValidatedDropDown class="wide"
                                               [label]="'Receive Duplicate Copy of Plan Materials'"
                                               [options]="ddllMailCopy"
                                               [selectedValue]="enrollment.AUTHREPCOPYIND"
                                               (onValueChange)="enrollment.AUTHREPCOPYIND =$event">
                                    </ValidatedDropDown>
                                </div>
                            </div>-->
                        </div>
                        <div class="row" *ngIf="false">
                            <div class="col-16">
                                <p class="qtip-note bottom-20"><strong>qTip Note:</strong> If legally authorized
                                    representative requests to receive a duplicate copy of plan materials in the mail,
                                    it will be generated through above collection of their mail address and selecting
                                    the “YES” response, otherwise select No.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <indvrep [hidden]="!isVisibleIndiv" [enrollmentindvrepViewModel]="enrollment" isSpanish="true"
                (appIndClick)="rblAppIndINDClick($event)"></indvrep>
            <div class="row" *ngIf="isMyAplgy">
                <div class="col-16">
                    <p class="blue-text"> Le pido disculpas, pero solo puedo tomar la inscripción del
                        beneficiario de Medicare o de una persona que esté autorizada para actuar en nombre.
                    </p>
                </div>
                <div class="col-16" *ngIf="isQtip">
                    <div>
                        <p class="qtip-note"><strong>qTip Note:</strong> Proceed to <u>“Section 7. Enrollment
                                End”</u>.<a (click)="SalesBenfDetails()" class="link">Click here</a></p>
                    </div>
                </div>
            </div>
            <!--Start  Beneficairy Info-->
            <div *ngIf="!rblbenfInfo || isAppInd">
                <div class="row">

                    <div class="col-16">
                        <p class="blue-text">
                            ¿Puede darme la siguiente información sobre {{spnIsBeneficiaryYour}}: nombre, inicial del
                            segundo nombre, apellido, sufijo, fecha de nacimiento, género, número telefónico, dirección
                            permanente y dirección de correo electrónico?
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <div class="input-wrapper">
                            <ValidatedTextField label="Nombre" [text]="enrollment.APPFN"
                                (onValueChange)="enrollment.APPFN = $event" (blur)="setEobName()" [validators]="[]"
                                [disabled]="disabled">
                            </ValidatedTextField>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="input-wrapper">
                            <ValidatedTextField label="Inicial del segundo nombre (opcional)" [text]="enrollment.APPMI"
                                [maxlength]="1" (onValueChange)="enrollment.APPMI = $event" [validators]="[]"
                                [disabled]="disabled">
                            </ValidatedTextField>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="input-wrapper">
                            <ValidatedTextField label="Apellido" [text]="enrollment.APPLN"
                                (onValueChange)="enrollment.APPLN = $event" (blur)="setEobName()" [validators]="[]"
                                [disabled]="disabled">
                            </ValidatedTextField>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5">
                        <div class="input-wrapper">
                            <ValidatedTextField class="wide" label="Sufijo (opcional)" [text]="enrollment.SUFFIX"
                                (onValueChange)="enrollment.SUFFIX = $event" [validators]="[]" [disabled]="disabled">
                            </ValidatedTextField>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-8">
                        <div class="input-wrapper">
                            <!--<label>Date of Birth (mm/dd/yyyy):</label>-->
                            <!--<JQDatePicker [selectedDate]="enrollmentViewModel.APPDOB"
                                    (elementClicked)="enrollmentViewModel.APPDOB = $event">
                    </JQDatePicker>-->
                            <ValidatedDateTextField label="Fecha de nacimiento" id="DOB" [date]="enrollment.APPDOB"
                                (onDateChange)="enrollment.APPDOB = $event"
                                [validators]="[validatedDate,notBlankValidator]" [disabled]="disabled">
                            </ValidatedDateTextField>
                        </div>
                    </div>
                    <div class="col-8">
                        <fieldset class="radio">
                            <legend>Género</legend>
                            <ValidatedRadioButtonGroup [options]="genderOptions" [selectedValue]="enrollment.APPGEN"
                                [radioGroupName]="'genderOptions'" (onValueChange)="SelectGender($event)"
                                [disabled]="disabled">
                            </ValidatedRadioButtonGroup>
                        </fieldset>
                    </div>
                </div>
                <div class="row">
                    <div class="col-8">
                        <div class="input-wrapper">
                            <MaskedValidatedTextField class="field" [label]="'Número de teléfono (opcional)'"
                                [text]="enrollment.APPPHONE" (onValueChange)="enrollment.APPPHONE = $event"
                                [maxlength]="10" [inputMask]="phoneNumberInputMask1" [validators]="[]">
                            </MaskedValidatedTextField>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-8">
                        <div class="input-wrapper">
                            <ValidatedTextField [label]="'Dirección 1'" [text]="enrollment.APPADD1" [validators]="[]"
                                (blur)="onBlur()" [disabled]="disabled" (onValueChange)="enrollment.APPADD1 = $event"
                                maxlength="40">
                            </ValidatedTextField>
                        </div>
                    </div>
                    <div class="col-8">
                        <div class="input-wrapper">
                            <ValidatedTextField [label]="'Dirección 2 (opcional)'" [text]="enrollment.APPADD2"
                                (blur)="onBlur()" [disabled]="disabled" (onValueChange)="enrollment.APPADD2= $event"
                                maxlength="40">
                            </ValidatedTextField>
                        </div>
                    </div>
                    <div class="col-8">
                        <div class="input-wrapper">
                            <ValidatedCheckbox class="centered-checkbox" [id]="'po-box'"
                                [label]="'CORREOS. Anulación de caja'" [checked]="enrollment.POBOX"
                                (onValueChange)="enrollment.POBOX= $event">
                            </ValidatedCheckbox>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-8">
                        <div class="input-wrapper">
                            <ValidatedTextField [label]="'Ciudad'" [text]="enrollment.APPCITY" [validators]="[]"
                                (blur)="onBlur()" [disabled]="disabled" (onValueChange)="enrollment.APPCITY= $event"
                                maxlength="40">
                            </ValidatedTextField>
                        </div>
                    </div>
                    <div class="col-5">
                        <div class="input-wrapper">
                            <ValidatedDropDown class="wide" [selectedValue]="enrollment.APPST" [label]="'Estado'"
                                [disabled]="disabled" (onValueChange)="SelectState($event)" [options]="states"
                                (blur)="onBlur()">
                            </ValidatedDropDown>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="input-wrapper">
                            <ValidatedTextField [label]="'Código postal'" [text]="enrollment.APPZIP" [validators]="[]"
                                (blur)="onBlur()" [disabled]="disabled" (onValueChange)="enrollment.APPZIP = $event"
                                maxlength="5">
                            </ValidatedTextField>
                        </div>
                    </div>

                </div>

                <div class="row">
                    <div class="col-8">
                        <div class="input-wrapper">
                            <ValidatedTextField class="" [label]="'Dirección de correo electrónico (opcional):'"
                                id="EmailAddress" [text]="enrollment.APPEMAIL"
                                (onValueChange)="enrollment.APPEMAIL = $event">

                            </ValidatedTextField>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <!--<div class="col-16" *ngIf="!ShowCurrentYearScript">
                        <p class="qtip-note bottom-20"><strong>qTip Note:</strong> If the permanent address provided is a P.O. Box, request an address other than a P.O. Box. If the enrollee does not have this address or is unable to provide another address, inform them that by not providing a valid permanent address, enrollment into the plan could be delayed or at risk of denial.</p>
                        <p class="blue-text">
                            Note: Enter email address while verifying verbally:
                            By providing us with (your/his/her) email address, (you/he/she) agree(s) to receive email communications from Aetna until you, he, she opt(s) out of further emails. (You/he/she) (have/has) the opportunity to opt-out at any time.
                        </p>
                    </div>-->
                    <div class="col-16">
                        <p class="blue-text" *ngIf="ShowCurrentYearScript"> Si la dirección permanente informada es una
                            casilla de correo, solicite una dirección que no sea una casilla de correo. Si la persona
                            inscripta no tiene esta dirección o no puede proporcionar otra dirección, infórmele que al
                            no brindar una dirección permanente válida, la inscripción se podría demorar o podría correr
                            el riesgo de ser denegada.</p>
                        <p class="blue-text" *ngIf="!ShowCurrentYearScript"> Si la dirección permanente informada es una
                            casilla de correo, solicite una dirección que no sea una casilla de correo. Si la persona
                            inscrita no tiene esta dirección o no puede proporcionar otra dirección, infórmele que al no
                            brindar una dirección permanente válida, la inscripción se podría demorar o podría correr el
                            riesgo de ser denegada.</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-16">
                        <p class="qtip-note bottom-20"><strong>qTip Note:</strong> Enter email address while verifying
                            verbally:</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-8">
                        <div class="input-wrapper">
                            <ValidatedTextField class="" [label]="'Dirección de correo electrónico'" id="EmailAddress"
                                [text]="enrollment.APPEMAIL" (onValueChange)="enrollment.APPEMAIL = $event">

                            </ValidatedTextField>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-16">
                        <p class="blue-text" *ngIf="ShowCurrentYearScript">
                            Al brindarnos su dirección de correo electrónico, acepta recibir comunicaciones de Aetna por
                            correo electrónico hasta que se excluya voluntariamente de futuros correos electrónicos.
                            Puede optar por la exclusión voluntaria en cualquier momento.
                        </p>
                        <p class="blue-text" *ngIf="!ShowCurrentYearScript">
                            Al brindarnos su dirección de correo electrónico, acepta recibir comunicados de Aetna por
                            correo electrónico hasta que decida excluirse de este servicio. Puede elegir dejar de
                            recibir correos electrónicos en cualquier momento.
                        </p>
                    </div>
                </div>
                <!--<fieldset class="radio" *ngIf="IsRbllongtermYes">
                    <legend class="blue-text bottom-10 limit-width">May I please have the Institution name and phone number?</legend>
                    <div class="row">
                        <div class="col-8">
                            <div class="input-wrapper">
                                <ValidatedTextField label="Institution Name"
                                                    [maxlength]="50"
                                                    [text]="enrollmentViewModel.LTCFACILITY"
                                                    (onValueChange)="enrollmentViewModel.LTCFACILITY= $event"
                                                    [disabled]="disabled">
                                </ValidatedTextField>
                            </div>
                        </div>
                        <div class="col-8">
                            <div class="input-wrapper">
                                <ValidatedTextField label="Phone Number (numbers only)"
                                                    [maxlength]="10"
                                                    [text]="enrollmentViewModel.LTCPHONE"
                                                    (onValueChange)="enrollmentViewModel.LTCPHONE= $event"
                                                    [validators]="[]"
                                                    [disabled]="disabled">
                                </ValidatedTextField>
                            </div>
                        </div>
                    </div>
                </fieldset>-->
                <fieldset>
                    <legend class="blue-text limit-width">¿Es su dirección postal la misma que su dirección permanente?
                    </legend>
                    <div class="row">
                        <div class="col-24">
                            <!--<input type="checkbox"
                                    class="option__input"
                                    id="same-as-business-address"
                                    [checked]="sameAsBusinessAddress"
                                    (click)="clickOnSameAsBusinessAddress()" />
                            <label for="same-as-business-address">  Mailing Address is the same as Permanent Address </label>-->
                            <div class="bottom-20">
                                <ValidatedCheckbox [id]="'same-as-business-address'"
                                    [label]="'La dirección postal es la misma que la dirección permanente'"
                                    [checked]="enrollment.ISSAMEADDRESS"
                                    (onValueChange)="clickOnSameAsBusinessAddress($event)">
                                </ValidatedCheckbox>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="IsSameAddress">
                        <fieldset>
                            <legend class="blue-text bottom-10 limit-width" *ngIf="ShowCurrentYearScript"> ¿Podría darme
                                la dirección postal?</legend>
                            <legend class="blue-text bottom-10 limit-width" *ngIf="!ShowCurrentYearScript"> ¿Podría
                                decirme la dirección postal?</legend>
                        </fieldset>

                        <div class="row">
                            <div class="col-8">
                                <div class="input-wrapper">
                                    <ValidatedTextField [label]="'Dirección 1'" [text]="enrollment.MAILADD1"
                                        [validators]="[]" (blur)="onBlur()" [disabled]="disabled"
                                        (onValueChange)="enrollment.MAILADD1= $event" maxlength="40">
                                    </ValidatedTextField>
                                </div>
                            </div>
                            <div class="col-8">
                                <div class="input-wrapper">
                                    <ValidatedTextField [label]="'Dirección 2 (opcional)'" [text]="enrollment.MAILADD2"
                                        (blur)="onBlur()" [disabled]="disabled"
                                        (onValueChange)="enrollment.MAILADD2= $event" maxlength="40">
                                    </ValidatedTextField>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <div class="input-wrapper">
                                    <ValidatedTextField [label]="'Ciudad'" [text]="enrollment.MAILCITY"
                                        [validators]="[]" (blur)="onBlur()" [disabled]="disabled"
                                        (onValueChange)="enrollment.MAILCITY = $event" maxlength="40">
                                    </ValidatedTextField>
                                </div>
                            </div>
                            <div class="col-5">
                                <div class="input-wrapper">
                                    <ValidatedDropDown class="wide" [selectedValue]="enrollment.MAILST"
                                        [label]="'Estado'" [disabled]="disabled"
                                        (onValueChange)="enrollment.MAILST = $event" [options]="mailingstates"
                                        (blur)="onBlur()">
                                    </ValidatedDropDown>
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="input-wrapper">
                                    <ValidatedTextField [label]="'Código postal'" [text]="enrollment.MAILZIP"
                                        [validators]="[]" (blur)="onBlur()" [disabled]="disabled"
                                        (onValueChange)="enrollment.MAILZIP = $event" maxlength="5">
                                    </ValidatedTextField>
                                </div>
                            </div>
                        </div>
                        <!--<div class="row">
                            <div class="col-16" *ngIf="ShowCurrentYearScript">
                                <p class="qtip-note bottom-20"><strong>qTip Note:</strong> If paper enrollment has been requested, proceed to <u>“Section 7. Enrollment End”</u>. <a (click)="SalesBenfDetails()"><strong> Click here</strong></a></p>
                            </div>
                        </div>-->
                        <!--<div class="row" *ngIf="isQtip">
                            <div class="col-16" *ngIf="!ShowCurrentYearScript">
                                <div class="col-16" *ngIf="checkPlanyear">
                                    <p class="qtip-note"><strong>qTip Note:</strong> If paper enrollment has been requested, proceed to  <u>“Section 7. Enrollment End”</u>. <a (click)="SalesBenfDetails()"><strong> Click here</strong></a></p>
                                </div>
                            </div>
                        </div>-->
                    </div>
                </fieldset>
            </div>
            <!--End  Beneficairy Info-->
            <div class="row" *ngIf="!rblbenfeno || isAppInd">
                <div class="col-24">
                    <button class="button primary" (click)="formSubmit()">Continue</button>
                </div>
            </div>
        </div>
    </div>
</div>